var _defs, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "check-mark-a",
    d: "M908,394 C902.444444,394 898,398.444444 898,404 C898,409.555556 902.444444,414 908,414 C913.555556,414 918,409.555556 918,404 C918,398.444444 913.555556,394 908,394 Z M913.222222,401.444444 L907.111111,408.111111 C906.888889,408.333333 906.555556,408.444444 906.333333,408.444444 C906.111111,408.444444 905.777778,408.333333 905.555556,408.111111 L902.777778,405.111111 C902.333333,404.666667 902.444444,404 902.888889,403.555556 C903.333333,403.111111 904,403.222222 904.444444,403.666667 L906.333333,405.777778 L911.666667,400 C912.111111,399.555556 912.777778,399.555556 913.222222,399.888889 C913.666667,400.222222 913.666667,401 913.222222,401.444444 Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#3CBA92",
    transform: "translate(-898 -394)",
    xlinkHref: "#check-mark-a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check-mark.dd408fb7c0d141a9a453ea0af3da47c7.svg";
export { ForwardRef as ReactComponent };